import React, {
    useEffect,
    useState,
    useRef,
} from "react";
import {
    Row,
    Col,
} from "../../ui/ot";
import { Bar, BarChart, CartesianGrid, XAxis, LabelList, Brush } from "recharts"
import {
    ChartConfig,
    ChartContainer,
    ChartTooltip,
    ChartTooltipContent,
    ChartLegend,
    ChartLegendContent
} from "../../ui/chart"

const ColumnChart = ({
    //數值類型的key
    chartConfig = {
        desktop: {
            label: "Desktop",
            color: "hsl(var(--chart-1))",
        },
    },
    //data
    chartData = [
        { month: "January", desktop: 186 },
        { month: "February", desktop: 305 },
        { month: "March", desktop: 237 },
        { month: "April", desktop: 73 },
        { month: "May", desktop: 209 },
        { month: "June", desktop: 214 },
    ],
    //X 軸顯示的名稱得key
    xDataKeyArr = ["month"],
    yDataKeyArr = ["desktop"],
    showLabel = true,
    showLegend = true,
    showBrush = true
}) => {
    return (<Row>
        <Col span={24}>
            <ChartContainer config={chartConfig}>
                <BarChart
                    accessibilityLayer
                    data={chartData}
                    margin={{
                        top: showLabel ? 20 : 0,
                    }}
                >
                    <CartesianGrid vertical={false} />
                    {
                        xDataKeyArr.map((xDataKey) => (
                            <XAxis
                                dataKey={xDataKey}
                                tickLine={false}
                                tickMargin={10}
                                axisLine={false}
                                tickFormatter={(value) => value}
                            />))
                    }

                    <ChartTooltip
                        cursor={false}
                        content={<ChartTooltipContent />}
                    />

                    {
                        (yDataKeyArr).map((yDataKey) => {
                            return (<Bar dataKey={yDataKey} fill={`var(--color-${yDataKey})`} radius={8}>
                                {showLabel && <LabelList
                                    position="top"
                                    offset={12}
                                    className="fill-foreground"
                                    fontSize={12}
                                />}
                            </Bar>)
                        })
                    }
                    {showLegend && <ChartLegend
                        className=" flex-wrap "
                        content={<ChartLegendContent />} />}
                    {showBrush && <Brush
                        height={20}
                    />}
                </BarChart>
            </ChartContainer>

        </Col>
    </Row>)
}
export { ColumnChart }

